import LoyaltyAccountLandingPageYourBenefits from './LoyaltyAccountLandingPageYourBenefits'
import LoyaltyAccountLandingPageUserActivities from './LoyaltyAccountLandingPageUserActivities'
import LoyaltyWhatsNewCarousel from '../loyaltyLandingPageSharedSections/LoyaltyWhatsNewCarousel'
import LoyaltyUpcomingEscapesBenefits from './LoyaltyUpcomingEscapesBenefits'

function LoyaltyAccountBenefitsContent() {
  return <>
    <LoyaltyUpcomingEscapesBenefits />
    <LoyaltyAccountLandingPageYourBenefits />
    <LoyaltyWhatsNewCarousel />
    <LoyaltyAccountLandingPageUserActivities />
  </>
}

export default LoyaltyAccountBenefitsContent
